import { render, staticRenderFns } from "./resaleDetailsModal.vue?vue&type=template&id=3438064e&"
import script from "./resaleDetailsModal.vue?vue&type=script&lang=js&"
export * from "./resaleDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports